/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateParticipationDto } from '../model';
// @ts-ignore
import type { ErrorResponseDto } from '../model';
// @ts-ignore
import type { ExpirePaymentResponseDto } from '../model';
// @ts-ignore
import type { GenerateEBibResponseDto } from '../model';
// @ts-ignore
import type { GenerateECertResponseDto } from '../model';
// @ts-ignore
import type { GetParticipationByIdResponseDto } from '../model';
// @ts-ignore
import type { GetParticipationResponseDto } from '../model';
// @ts-ignore
import type { PaginatedParticipationsResponseDto } from '../model';
// @ts-ignore
import type { UpdateUserParticipationDto } from '../model';
// @ts-ignore
import type { UpdateUserParticipationResponseDto } from '../model';
// @ts-ignore
import type { UserParticipationSummaryDto } from '../model';
/**
 * ParticipationsApi - axios parameter creator
 * @export
 */
export const ParticipationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Join a challenge category (create new participation)
         * @param {CreateParticipationDto} createParticipationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerCreateParticipation: async (createParticipationDto: CreateParticipationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createParticipationDto' is not null or undefined
            assertParamExists('participationsControllerCreateParticipation', 'createParticipationDto', createParticipationDto)
            const localVarPath = `/api/participations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createParticipationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Expire payment for a participation (abandon payment)
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerExpirePayment: async (participationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participationId' is not null or undefined
            assertParamExists('participationsControllerExpirePayment', 'participationId', participationId)
            const localVarPath = `/api/participations/{participationId}/expire-payment`
                .replace(`{${"participationId"}}`, encodeURIComponent(String(participationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export participations CSV with optional filters
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerExportCsvStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerExportCsvPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {string | null} [challengeId] Filter by challenge ID
         * @param {ParticipationsControllerExportCsvParticipationStatusEnum} [participationStatus] Filter by participation status
         * @param {boolean | null} [completedOnly] Show only participations with 100% progress or above
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerExportCsv: async (page?: number, limit?: number, search?: string, status?: ParticipationsControllerExportCsvStatusEnum, paymentStatus?: ParticipationsControllerExportCsvPaymentStatusEnum, challengeId?: string | null, participationStatus?: ParticipationsControllerExportCsvParticipationStatusEnum, completedOnly?: boolean | null, organizerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/participations/export/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (paymentStatus !== undefined) {
                localVarQueryParameter['paymentStatus'] = paymentStatus;
            }

            if (challengeId !== undefined) {
                localVarQueryParameter['challengeId'] = challengeId;
            }

            if (participationStatus !== undefined) {
                localVarQueryParameter['participationStatus'] = participationStatus;
            }

            if (completedOnly !== undefined) {
                localVarQueryParameter['completedOnly'] = completedOnly;
            }

            if (organizerId !== undefined) {
                localVarQueryParameter['organizerId'] = organizerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user\'s challenge category participations with progress data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/participations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user\'s challenge category participations with pagination and progress data
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerFindAllPaginatedStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerFindAllPaginatedPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {string | null} [challengeId] Filter by challenge ID
         * @param {ParticipationsControllerFindAllPaginatedParticipationStatusEnum} [participationStatus] Filter by participation status
         * @param {boolean | null} [completedOnly] Show only participations with 100% progress or above
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindAllPaginated: async (page?: number, limit?: number, search?: string, status?: ParticipationsControllerFindAllPaginatedStatusEnum, paymentStatus?: ParticipationsControllerFindAllPaginatedPaymentStatusEnum, challengeId?: string | null, participationStatus?: ParticipationsControllerFindAllPaginatedParticipationStatusEnum, completedOnly?: boolean | null, organizerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/participations/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (paymentStatus !== undefined) {
                localVarQueryParameter['paymentStatus'] = paymentStatus;
            }

            if (challengeId !== undefined) {
                localVarQueryParameter['challengeId'] = challengeId;
            }

            if (participationStatus !== undefined) {
                localVarQueryParameter['participationStatus'] = participationStatus;
            }

            if (completedOnly !== undefined) {
                localVarQueryParameter['completedOnly'] = completedOnly;
            }

            if (organizerId !== undefined) {
                localVarQueryParameter['organizerId'] = organizerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated participations by challengeId (admin)
         * @param {string} challengeId Challenge ID
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerFindByChallengeIdPaginatedStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindByChallengeIdPaginated: async (challengeId: string, page?: number, limit?: number, search?: string, status?: ParticipationsControllerFindByChallengeIdPaginatedStatusEnum, paymentStatus?: ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('participationsControllerFindByChallengeIdPaginated', 'challengeId', challengeId)
            const localVarPath = `/api/participations/challenges/{challengeId}/paginated`
                .replace(`{${"challengeId"}}`, encodeURIComponent(String(challengeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (paymentStatus !== undefined) {
                localVarQueryParameter['paymentStatus'] = paymentStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single challenge category participation by ID with progress data
         * @param {string} participationId Challenge category participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindParticipationById: async (participationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participationId' is not null or undefined
            assertParamExists('participationsControllerFindParticipationById', 'participationId', participationId)
            const localVarPath = `/api/participations/{participationId}`
                .replace(`{${"participationId"}}`, encodeURIComponent(String(participationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user\'s participations summary with essential information only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindUserParticipationsSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/participations/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate e-bib data for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerGenerateEBib: async (participationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participationId' is not null or undefined
            assertParamExists('participationsControllerGenerateEBib', 'participationId', participationId)
            const localVarPath = `/api/participations/{participationId}/generate-ebib`
                .replace(`{${"participationId"}}`, encodeURIComponent(String(participationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerGenerateECertData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/participations/generate-ecert-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate e-certificate data for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerGenerateECertificate: async (participationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participationId' is not null or undefined
            assertParamExists('participationsControllerGenerateECertificate', 'participationId', participationId)
            const localVarPath = `/api/participations/{participationId}/generate-ecert`
                .replace(`{${"participationId"}}`, encodeURIComponent(String(participationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerGenerateEbibData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/participations/generate-ebib-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update finisher shirt size and delivery address for ongoing participation
         * @param {string} participationId Challenge category participation ID
         * @param {UpdateUserParticipationDto} updateUserParticipationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerUpdateParticipation: async (participationId: string, updateUserParticipationDto: UpdateUserParticipationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participationId' is not null or undefined
            assertParamExists('participationsControllerUpdateParticipation', 'participationId', participationId)
            // verify required parameter 'updateUserParticipationDto' is not null or undefined
            assertParamExists('participationsControllerUpdateParticipation', 'updateUserParticipationDto', updateUserParticipationDto)
            const localVarPath = `/api/participations/{participationId}`
                .replace(`{${"participationId"}}`, encodeURIComponent(String(participationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserParticipationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParticipationsApi - functional programming interface
 * @export
 */
export const ParticipationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParticipationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Join a challenge category (create new participation)
         * @param {CreateParticipationDto} createParticipationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerCreateParticipation(createParticipationDto: CreateParticipationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetParticipationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerCreateParticipation(createParticipationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerCreateParticipation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Expire payment for a participation (abandon payment)
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerExpirePayment(participationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpirePaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerExpirePayment(participationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerExpirePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export participations CSV with optional filters
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerExportCsvStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerExportCsvPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {string | null} [challengeId] Filter by challenge ID
         * @param {ParticipationsControllerExportCsvParticipationStatusEnum} [participationStatus] Filter by participation status
         * @param {boolean | null} [completedOnly] Show only participations with 100% progress or above
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerExportCsv(page?: number, limit?: number, search?: string, status?: ParticipationsControllerExportCsvStatusEnum, paymentStatus?: ParticipationsControllerExportCsvPaymentStatusEnum, challengeId?: string | null, participationStatus?: ParticipationsControllerExportCsvParticipationStatusEnum, completedOnly?: boolean | null, organizerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerExportCsv(page, limit, search, status, paymentStatus, challengeId, participationStatus, completedOnly, organizerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerExportCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user\'s challenge category participations with progress data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerFindAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetParticipationResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerFindAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user\'s challenge category participations with pagination and progress data
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerFindAllPaginatedStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerFindAllPaginatedPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {string | null} [challengeId] Filter by challenge ID
         * @param {ParticipationsControllerFindAllPaginatedParticipationStatusEnum} [participationStatus] Filter by participation status
         * @param {boolean | null} [completedOnly] Show only participations with 100% progress or above
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerFindAllPaginated(page?: number, limit?: number, search?: string, status?: ParticipationsControllerFindAllPaginatedStatusEnum, paymentStatus?: ParticipationsControllerFindAllPaginatedPaymentStatusEnum, challengeId?: string | null, participationStatus?: ParticipationsControllerFindAllPaginatedParticipationStatusEnum, completedOnly?: boolean | null, organizerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedParticipationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerFindAllPaginated(page, limit, search, status, paymentStatus, challengeId, participationStatus, completedOnly, organizerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerFindAllPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated participations by challengeId (admin)
         * @param {string} challengeId Challenge ID
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerFindByChallengeIdPaginatedStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerFindByChallengeIdPaginated(challengeId: string, page?: number, limit?: number, search?: string, status?: ParticipationsControllerFindByChallengeIdPaginatedStatusEnum, paymentStatus?: ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedParticipationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerFindByChallengeIdPaginated(challengeId, page, limit, search, status, paymentStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerFindByChallengeIdPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a single challenge category participation by ID with progress data
         * @param {string} participationId Challenge category participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerFindParticipationById(participationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetParticipationByIdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerFindParticipationById(participationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerFindParticipationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user\'s participations summary with essential information only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerFindUserParticipationsSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserParticipationSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerFindUserParticipationsSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerFindUserParticipationsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate e-bib data for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerGenerateEBib(participationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateEBibResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerGenerateEBib(participationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerGenerateEBib']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerGenerateECertData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerGenerateECertData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerGenerateECertData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate e-certificate data for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerGenerateECertificate(participationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateECertResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerGenerateECertificate(participationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerGenerateECertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerGenerateEbibData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerGenerateEbibData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerGenerateEbibData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update finisher shirt size and delivery address for ongoing participation
         * @param {string} participationId Challenge category participation ID
         * @param {UpdateUserParticipationDto} updateUserParticipationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participationsControllerUpdateParticipation(participationId: string, updateUserParticipationDto: UpdateUserParticipationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserParticipationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.participationsControllerUpdateParticipation(participationId, updateUserParticipationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ParticipationsApi.participationsControllerUpdateParticipation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ParticipationsApi - factory interface
 * @export
 */
export const ParticipationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParticipationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Join a challenge category (create new participation)
         * @param {CreateParticipationDto} createParticipationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerCreateParticipation(createParticipationDto: CreateParticipationDto, options?: RawAxiosRequestConfig): AxiosPromise<GetParticipationResponseDto> {
            return localVarFp.participationsControllerCreateParticipation(createParticipationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Expire payment for a participation (abandon payment)
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerExpirePayment(participationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExpirePaymentResponseDto> {
            return localVarFp.participationsControllerExpirePayment(participationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export participations CSV with optional filters
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerExportCsvStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerExportCsvPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {string | null} [challengeId] Filter by challenge ID
         * @param {ParticipationsControllerExportCsvParticipationStatusEnum} [participationStatus] Filter by participation status
         * @param {boolean | null} [completedOnly] Show only participations with 100% progress or above
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerExportCsv(page?: number, limit?: number, search?: string, status?: ParticipationsControllerExportCsvStatusEnum, paymentStatus?: ParticipationsControllerExportCsvPaymentStatusEnum, challengeId?: string | null, participationStatus?: ParticipationsControllerExportCsvParticipationStatusEnum, completedOnly?: boolean | null, organizerId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.participationsControllerExportCsv(page, limit, search, status, paymentStatus, challengeId, participationStatus, completedOnly, organizerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user\'s challenge category participations with progress data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetParticipationResponseDto>> {
            return localVarFp.participationsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user\'s challenge category participations with pagination and progress data
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerFindAllPaginatedStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerFindAllPaginatedPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {string | null} [challengeId] Filter by challenge ID
         * @param {ParticipationsControllerFindAllPaginatedParticipationStatusEnum} [participationStatus] Filter by participation status
         * @param {boolean | null} [completedOnly] Show only participations with 100% progress or above
         * @param {string} [organizerId] Filter by organizer ID (for internal use)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindAllPaginated(page?: number, limit?: number, search?: string, status?: ParticipationsControllerFindAllPaginatedStatusEnum, paymentStatus?: ParticipationsControllerFindAllPaginatedPaymentStatusEnum, challengeId?: string | null, participationStatus?: ParticipationsControllerFindAllPaginatedParticipationStatusEnum, completedOnly?: boolean | null, organizerId?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedParticipationsResponseDto> {
            return localVarFp.participationsControllerFindAllPaginated(page, limit, search, status, paymentStatus, challengeId, participationStatus, completedOnly, organizerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated participations by challengeId (admin)
         * @param {string} challengeId Challenge ID
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search term for filtering results
         * @param {ParticipationsControllerFindByChallengeIdPaginatedStatusEnum} [status] Status filter for submissions
         * @param {ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum} [paymentStatus] Filter by payment status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindByChallengeIdPaginated(challengeId: string, page?: number, limit?: number, search?: string, status?: ParticipationsControllerFindByChallengeIdPaginatedStatusEnum, paymentStatus?: ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedParticipationsResponseDto> {
            return localVarFp.participationsControllerFindByChallengeIdPaginated(challengeId, page, limit, search, status, paymentStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single challenge category participation by ID with progress data
         * @param {string} participationId Challenge category participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindParticipationById(participationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetParticipationByIdResponseDto> {
            return localVarFp.participationsControllerFindParticipationById(participationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user\'s participations summary with essential information only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerFindUserParticipationsSummary(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserParticipationSummaryDto>> {
            return localVarFp.participationsControllerFindUserParticipationsSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate e-bib data for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerGenerateEBib(participationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateEBibResponseDto> {
            return localVarFp.participationsControllerGenerateEBib(participationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerGenerateECertData(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.participationsControllerGenerateECertData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate e-certificate data for a specific participation
         * @param {string} participationId Participation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerGenerateECertificate(participationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateECertResponseDto> {
            return localVarFp.participationsControllerGenerateECertificate(participationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerGenerateEbibData(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.participationsControllerGenerateEbibData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update finisher shirt size and delivery address for ongoing participation
         * @param {string} participationId Challenge category participation ID
         * @param {UpdateUserParticipationDto} updateUserParticipationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participationsControllerUpdateParticipation(participationId: string, updateUserParticipationDto: UpdateUserParticipationDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUserParticipationResponseDto> {
            return localVarFp.participationsControllerUpdateParticipation(participationId, updateUserParticipationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParticipationsApi - object-oriented interface
 * @export
 * @class ParticipationsApi
 * @extends {BaseAPI}
 */
export class ParticipationsApi extends BaseAPI {
    /**
     * 
     * @summary Join a challenge category (create new participation)
     * @param {CreateParticipationDto} createParticipationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerCreateParticipation(createParticipationDto: CreateParticipationDto, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerCreateParticipation(createParticipationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Expire payment for a participation (abandon payment)
     * @param {string} participationId Participation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerExpirePayment(participationId: string, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerExpirePayment(participationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export participations CSV with optional filters
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {string} [search] Search term for filtering results
     * @param {ParticipationsControllerExportCsvStatusEnum} [status] Status filter for submissions
     * @param {ParticipationsControllerExportCsvPaymentStatusEnum} [paymentStatus] Filter by payment status
     * @param {string | null} [challengeId] Filter by challenge ID
     * @param {ParticipationsControllerExportCsvParticipationStatusEnum} [participationStatus] Filter by participation status
     * @param {boolean | null} [completedOnly] Show only participations with 100% progress or above
     * @param {string} [organizerId] Filter by organizer ID (for internal use)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerExportCsv(page?: number, limit?: number, search?: string, status?: ParticipationsControllerExportCsvStatusEnum, paymentStatus?: ParticipationsControllerExportCsvPaymentStatusEnum, challengeId?: string | null, participationStatus?: ParticipationsControllerExportCsvParticipationStatusEnum, completedOnly?: boolean | null, organizerId?: string, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerExportCsv(page, limit, search, status, paymentStatus, challengeId, participationStatus, completedOnly, organizerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user\'s challenge category participations with progress data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerFindAll(options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user\'s challenge category participations with pagination and progress data
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {string} [search] Search term for filtering results
     * @param {ParticipationsControllerFindAllPaginatedStatusEnum} [status] Status filter for submissions
     * @param {ParticipationsControllerFindAllPaginatedPaymentStatusEnum} [paymentStatus] Filter by payment status
     * @param {string | null} [challengeId] Filter by challenge ID
     * @param {ParticipationsControllerFindAllPaginatedParticipationStatusEnum} [participationStatus] Filter by participation status
     * @param {boolean | null} [completedOnly] Show only participations with 100% progress or above
     * @param {string} [organizerId] Filter by organizer ID (for internal use)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerFindAllPaginated(page?: number, limit?: number, search?: string, status?: ParticipationsControllerFindAllPaginatedStatusEnum, paymentStatus?: ParticipationsControllerFindAllPaginatedPaymentStatusEnum, challengeId?: string | null, participationStatus?: ParticipationsControllerFindAllPaginatedParticipationStatusEnum, completedOnly?: boolean | null, organizerId?: string, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerFindAllPaginated(page, limit, search, status, paymentStatus, challengeId, participationStatus, completedOnly, organizerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated participations by challengeId (admin)
     * @param {string} challengeId Challenge ID
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {string} [search] Search term for filtering results
     * @param {ParticipationsControllerFindByChallengeIdPaginatedStatusEnum} [status] Status filter for submissions
     * @param {ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum} [paymentStatus] Filter by payment status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerFindByChallengeIdPaginated(challengeId: string, page?: number, limit?: number, search?: string, status?: ParticipationsControllerFindByChallengeIdPaginatedStatusEnum, paymentStatus?: ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerFindByChallengeIdPaginated(challengeId, page, limit, search, status, paymentStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single challenge category participation by ID with progress data
     * @param {string} participationId Challenge category participation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerFindParticipationById(participationId: string, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerFindParticipationById(participationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user\'s participations summary with essential information only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerFindUserParticipationsSummary(options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerFindUserParticipationsSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate e-bib data for a specific participation
     * @param {string} participationId Participation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerGenerateEBib(participationId: string, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerGenerateEBib(participationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerGenerateECertData(options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerGenerateECertData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate e-certificate data for a specific participation
     * @param {string} participationId Participation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerGenerateECertificate(participationId: string, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerGenerateECertificate(participationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerGenerateEbibData(options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerGenerateEbibData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update finisher shirt size and delivery address for ongoing participation
     * @param {string} participationId Challenge category participation ID
     * @param {UpdateUserParticipationDto} updateUserParticipationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipationsApi
     */
    public participationsControllerUpdateParticipation(participationId: string, updateUserParticipationDto: UpdateUserParticipationDto, options?: RawAxiosRequestConfig) {
        return ParticipationsApiFp(this.configuration).participationsControllerUpdateParticipation(participationId, updateUserParticipationDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ParticipationsControllerExportCsvStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const;
export type ParticipationsControllerExportCsvStatusEnum = typeof ParticipationsControllerExportCsvStatusEnum[keyof typeof ParticipationsControllerExportCsvStatusEnum];
/**
 * @export
 */
export const ParticipationsControllerExportCsvPaymentStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;
export type ParticipationsControllerExportCsvPaymentStatusEnum = typeof ParticipationsControllerExportCsvPaymentStatusEnum[keyof typeof ParticipationsControllerExportCsvPaymentStatusEnum];
/**
 * @export
 */
export const ParticipationsControllerExportCsvParticipationStatusEnum = {
    Ongoing: 'ongoing',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;
export type ParticipationsControllerExportCsvParticipationStatusEnum = typeof ParticipationsControllerExportCsvParticipationStatusEnum[keyof typeof ParticipationsControllerExportCsvParticipationStatusEnum];
/**
 * @export
 */
export const ParticipationsControllerFindAllPaginatedStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const;
export type ParticipationsControllerFindAllPaginatedStatusEnum = typeof ParticipationsControllerFindAllPaginatedStatusEnum[keyof typeof ParticipationsControllerFindAllPaginatedStatusEnum];
/**
 * @export
 */
export const ParticipationsControllerFindAllPaginatedPaymentStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;
export type ParticipationsControllerFindAllPaginatedPaymentStatusEnum = typeof ParticipationsControllerFindAllPaginatedPaymentStatusEnum[keyof typeof ParticipationsControllerFindAllPaginatedPaymentStatusEnum];
/**
 * @export
 */
export const ParticipationsControllerFindAllPaginatedParticipationStatusEnum = {
    Ongoing: 'ongoing',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;
export type ParticipationsControllerFindAllPaginatedParticipationStatusEnum = typeof ParticipationsControllerFindAllPaginatedParticipationStatusEnum[keyof typeof ParticipationsControllerFindAllPaginatedParticipationStatusEnum];
/**
 * @export
 */
export const ParticipationsControllerFindByChallengeIdPaginatedStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const;
export type ParticipationsControllerFindByChallengeIdPaginatedStatusEnum = typeof ParticipationsControllerFindByChallengeIdPaginatedStatusEnum[keyof typeof ParticipationsControllerFindByChallengeIdPaginatedStatusEnum];
/**
 * @export
 */
export const ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;
export type ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum = typeof ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum[keyof typeof ParticipationsControllerFindByChallengeIdPaginatedPaymentStatusEnum];
